import CompletedIcon from 'assets/myAppointments/appointmentsList/completed.svg';
import FailedIcon from 'assets/myAppointments/appointmentsList/failed.svg';
import OverdueIcon from 'assets/myAppointments/appointmentsList/overdue.svg';
import TodayIcon from 'assets/myAppointments/appointmentsList/today.svg';
import UpcomingIcon from 'assets/myAppointments/appointmentsList/upcoming.svg';
import CheckIcon from 'assets/myAppointments/markOutcome/check.svg';
import ClockPurpleIcon from 'assets/myAppointments/markOutcome/clock.svg';
import CloseIcon from 'assets/myAppointments/markOutcome/close.svg';
import InfoIcon from 'assets/myAppointments/markOutcome/info.svg';
import UnreachableIcon from 'assets/myAppointments/markOutcome/unreachable.svg';

export const STATUS_CONFIG = {
  overdue: {
    label: 'Overdue',
    icon: OverdueIcon,
    color: '#e63946',
    bg: '#ffe2e2',
    gradient: 'linear-gradient(135deg, #FEF2F2 0%, #FFF1F2 50%, #FDF2F8 100%)',
    borderColor: 'transparent',
  },
  today: {
    label: 'Today',
    icon: TodayIcon,
    color: '#faa11c',
    bg: '#FAA11C1A',
    gradient: '#FFFBEB',
    borderColor: 'transparent',
  },
  upcoming: {
    label: 'Upcoming',
    icon: UpcomingIcon,
    color: '#15c7a7',
    bg: '#D0FAE5',
    gradient: '#EFFDF9',
    borderColor: 'transparent',
  },
  completed: {
    label: 'Completed',
    icon: CompletedIcon,
    color: '#2d6cdf',
    bg: '#2D6CDF1A',
    gradient: '#F3F5FF',
    borderColor: 'transparent',
  },
  refused: {
    label: 'Failed',
    icon: FailedIcon,
    color: '#62748e',
    bg: '#e2e8f0',
    gradient: '#f5f6f7',
    borderColor: 'transparent',
  },
};

export const INITIAL_FIELD_DATA = {
  searchName: '',
  searchAddress: '',
  searchMethod: '',
  status: null,
  product: null,
  offer: null,
  source: null,
  priority: null,
  assignee: null,
  createdFrom: null,
  createdTo: null,
  lastActivityFrom: null,
  lastActivityTo: null,
  assignedFrom: null,
  assignedTo: null,
  sort: 'newest',
};
export const STATUS_OPTIONS = [
  { value: 'Pending', label: 'Pending' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Refused', label: 'Refused' },
];
export const OFFER_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
];
export const URGENCY_OPTIONS = [
  { value: 'Overdue', label: 'Overdue' },
  { value: 'Today', label: 'Today' },
  { value: 'Upcoming', label: 'Upcoming' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Refused', label: 'Refused' },
];
export const RECIPIENTO_PTIONS = [
  { value: 'john_doe', label: 'John Doe' },
  { value: 'jane_smith', label: 'Jane Smith' },
];
export const INITIAL_DATA = [
  {
    id: 'routers',
    name: 'Router',
    items: [
      { id: 1, name: 'TP-Link Archer AX50', available: 15, qty: 0 },
      { id: 2, name: 'ASUS RT-AX88U', available: 8, qty: 0 },
      { id: 3, name: 'Netgear Nighthawk', available: 12, qty: 0 },
    ],
  },
  {
    id: 'cables',
    name: 'Cable',
    items: [
      { id: 4, name: 'CAT6 Ethernet Cable (10m)', available: 50, qty: 0 },
      { id: 5, name: 'HDMI Cable (2m)', available: 30, qty: 0 },
    ],
  },
  {
    id: 'decoders',
    name: 'Decoder',
    items: [
      { id: 6, name: 'HD Set-Top Box', available: 20, qty: 0 },
      { id: 7, name: '4K Ultra HD Decoder', available: 6, qty: 0 },
      { id: 8, name: 'Smart TV Box', available: 14, qty: 0 },
    ],
  },
];
export const OUTCOMES = [
  {
    id: 'successful',
    label: 'Successful',
    desc: 'Connection completed successfully',
    icon: CheckIcon,
    color: '#15C7A7',
    bg: '#15C7A71A',
    requiresInventory: true,
  },
  {
    id: 'partial',
    label: 'Partial',
    desc: 'Partially completed, needs follow-up',
    icon: InfoIcon,
    color: '#FAA11C',
    bg: '#FAA11C1A',
    requiresInventory: true,
  },
  {
    id: 'postponed',
    label: 'Postponed',
    desc: 'Reschedule to another date',
    icon: ClockPurpleIcon,
    color: '#8B5CF6',
    bg: '#8B5CF61A',
    requiresInventory: false,
  },
  {
    id: 'refused',
    label: 'Refused',
    desc: 'Customer refused service',
    icon: CloseIcon,
    color: '#EF4444',
    bg: '#E639461A',
    requiresInventory: false,
  },
  {
    id: 'unreachable',
    label: 'Unreachable',
    desc: 'Lead was not reachable',
    icon: UnreachableIcon,
    color: '#6C757D',
    bg: '#ffffff',
    requiresInventory: false,
    fullWidth: true,
  },
];
